import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBHXiVWZPIwcWtVY-_QNVWNRh0evj8B7sU",
  authDomain: "mattwf.firebaseapp.com",
  projectId: "mattwf",
  storageBucket: "mattwf.appspot.com",
  messagingSenderId: "434264318770",
  appId: "1:434264318770:web:46f603f2b5e0bb06ab2d2b",
};

//Initialize Firebase
firebase.initializeApp(firebaseConfig);

//Initialize Services
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
const projectStorage = firebase.storage();

//Timestamp
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectFirestore, projectAuth, projectStorage, timestamp };
